import ContentWrapper from "@/components/wrappers/ContentWrapper";
import { useFilterSearchParams } from "@/utils/hooksUtils";
import { useState } from "react";
import { DEFAULT_FILTER_COVERAGE_LIMITS_QUERY_PARAMS } from "../api";
import { CoverageLimitForm } from "../components/forms/CoverageLimitForm";
import { CoverageLimitFilterView } from "../components/views/CoverageLimitFilterView";
import { CoverageLimitTableView } from "../components/views/CoverageLimitTableView";
import { CoverageLimit, CoverageLimitFilterPageRequest } from "../types";

export const CoverageLimitListContainer = () => {
  const [limitFormOpen, setLimitFormOpen] = useState(false);
  const [limitToUpdate, setLimitToUpdate] = useState<CoverageLimit>();

  const searchParams = useFilterSearchParams<CoverageLimitFilterPageRequest>({
    params: ["institutionIds"],
    defaultQueryParamsObject: DEFAULT_FILTER_COVERAGE_LIMITS_QUERY_PARAMS,
  });

  const handleCreateClick = () => {
    setLimitFormOpen(true);
  };

  const handleUpdateClick = (limit: CoverageLimit) => {
    setLimitFormOpen(true);
    setLimitToUpdate(limit);
  };

  const handleFormCancel = () => {
    setLimitFormOpen(false);
    setLimitToUpdate(undefined);
  };

  return (
    <ContentWrapper>
      <CoverageLimitFilterView searchParams={searchParams} onCreateClick={handleCreateClick} />

      <CoverageLimitTableView searchParams={searchParams} onUpdateClick={handleUpdateClick} />

      <CoverageLimitForm coverageLimit={limitToUpdate} open={limitFormOpen} onFormCancel={handleFormCancel} />
    </ContentWrapper>
  );
};
